// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--fd7cf";
export var screen1__button = "screen1-module--screen1__button--7b589";
export var screen1__course = "screen1-module--screen1__course--e5455";
export var screen1__info = "screen1-module--screen1__info--27951";
export var screen1__instruments = "screen1-module--screen1__instruments--44ade";
export var screen1__title = "screen1-module--screen1__title--991bc";